<!-- The add/edit template modal -->
<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    <div class="modal-header-left">
      <h4 class="modal-title">{{ toBeUpdated() ? "Edit" : "Add" }} Template</h4>
    </div>
    <div class="modal-header-right">
      <button type="button" class="close" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <!-- Modal body -->
  <form class="modal-body" [formGroup]="templateForm" (ngSubmit)="onSubmit()">
    <div class="modal-body-inner">
      <div class="form-custom-div">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <app-input [form]="templateForm" label="Template Name" placeholder="Enter template name"
              controlName="Name"></app-input>
          </div>
          <div class="col-lg-12 col-md-12">
            <div class="form-group">
              <app-textarea [form]="templateForm" label="Description" controlName="Description"></app-textarea>
            </div>
          </div>
          <div class="col-lg-12 col-md-12">
            <div class="form-group">
              <app-drag-upload [form]="templateForm" controlName="Template" [allowedFileSize]="allowedFileSize"
                label="Upload {{ toBeUpdated() ? 'New' : '' }} Template" title="" subTitle=""
                (value)="dragFileEvent($event)" [clear]="clearDragUpload"></app-drag-upload>
                <p class="text-danger mx-1" *ngIf="dragValue.invalid">{{ exceedSizeMessage }}</p>
            </div>
            <div class="row m-1" style="padding: 5px 0 !important" *ngIf="this.existingTemplateName !== ''">
              <a title="Download Document" aria-label="Download Document" class="view-document"
                (click)="downloadTemplate()" href="javascript:void(0)">
                <i class="icon-description mr-2" style="vertical-align: middle !important;"></i>
                {{ this.existingTemplateName }}
              </a>
              <a title="Edit Document" aria-label="Edit Document"
                *ngIf="this.existingTemplateName.includes('.doc')"
                (click)="editTemplate()" class="d-flex align-items-center mx-1">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 2v6a2 2 0 0 0 2 2h4.92c-.596.22-1.144.554-1.558.97l-6.05 6.092a2.815 2.815 0 0 0-.728 1.279l-.525 2.03A2.082 2.082 0 0 0 10.3 22H5.5A1.5 1.5 0 0 1 4 20.5v-17A1.5 1.5 0 0 1 5.5 2H12Z"
                    fill="var(--opengov-primary-blurple)" />
                  <path
                    d="M13.5 2.5V8a.5.5 0 0 0 .5.5h5.5l-6-6ZM12.196 17.572l5.902-5.902a2.285 2.285 0 1 1 3.233 3.232l-5.903 5.902a2.684 2.684 0 0 1-1.247.707l-1.831.457a1.087 1.087 0 0 1-1.318-1.318l.457-1.83c.118-.473.362-.904.707-1.248Z"
                    fill="var(--opengov-primary-blurple)" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer-bottom">
      <app-modal-action-btns [form]="templateForm" (onReject)="close()"
        [disabled]="dragValue.invalid"></app-modal-action-btns>
    </div>
  </form>
</div>

<ng-template #selectTable let-modal>
  <!-- The modal -->
  <div class="modal-content">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="modal-header-left">
        <h4 class="modal-title">Edit Template</h4>
      </div>
      <div class="modal-header-right">
        <button type="button" class="close" (click)="modal.close()">
          <i class="icon-close"></i>
        </button>
      </div>
    </div>
    <!-- Modal body -->
    <form
    [formGroup]="tableForm"
    class="modal-body"
    (ngSubmit)="onSelectTableSubmit();modal.close()"
  >
      <div class="modal-body-inner">
        <div class="form-custom-div">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <app-select
                [form]="tableForm"
                [options]="getTables()"
                label="Select a Table for Merge"
                controlName="TableKey"
                [isLoading]="isTablesLoading[applicationKey]"
                [isError]="isTablesLoading['error-'+applicationKey]"
              ></app-select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer-bottom">
        <app-modal-action-btns
          [form]="tableForm"
          (onReject)="modal.close()"
        ></app-modal-action-btns>
      </div>
    </form>
  </div>
</ng-template>
